export default [
    583,
    471,
    474,
    475,
    476,
    653,
    829,
    1004,
    1181,
    1362,
    1547,
    683,
    419,
    333,
    342,
    437,
    619,
    890,
    1520,
    1788,
    2145,
    2587,
    2582,
    2394,
    2024,
    1464,
    1549,
    1725,
    1903,
    2262,
    2532,
    2713,
    2804,
    2723,
    2458,
    577,
    7,
    811,
    1712,
    1542,
    742,
    90,
    1081,
    907,
    461,
    280,
    546,
    1445,
    1721,
    1545,
    1364,
    1361,
    3257,
    560,
    1440,
    925,
    124,
    10,
    371,
    291,
    9,
    191,
    301,
    223,
    132,
    302,
    574,
    420,
    255,
    162,
    322,
    592,
    789,
    449,
    269,
    413,
    503,
    326,
    55,
    43,
    399,
    581,
    235,
    54,
    494,
    763,
    1128,
    1046,
    681,
    680,
    679,
    2025,
    1938,
    1489,
    1575,
    2559,
    1830,
    1551,
    1999,
    2362,
    1924,
    1651,
    2001,
    2540,
    2368,
    2091,
    2893,
    2353,
    1717,
    1985,
    3067,
    2622,
    1807,
    1894,
    2522,
    2973,
    2887,
    2527,
    2437,
    2614,
    2795,
    2350,
    2078,
    2253,
    2792,
    3066,
    2890,
    2169,
    2165,
    2704,
    3158,
    2814,
    2273,
    2179,
    2623,
    3164,
    3167,
    2720,
    2359,
    3074,
    3080,
    2636,
    2269,
    3076,
    3348,
    3265,
    2903,
    3353,
    3538,
    2822,
    3359,
    3551,
    3460,
    3189,
    3457,
    3552,
    3100,
    3542,
    3011,
    2279,
    2094,
    2185,
    2009,
    1829,
    1648,
    1734,
    1824,
    1826,
    1560,
    1290,
    1287,
    1288,
    1112,
    1022,
    932,
    1018,
    1110,
    843,
    752,
    747,
    745,
    656,
    386,
    385,
    207,
    116,
    108,
    104,
    106,
    21,
    20,
    16,
    192,
    283,
    375,
    554,
    731,
    729,
    730,
    640,
    456,
    277,
    187,
    92,
    95,
    185,
    542,
    720,
    721,
    723,
    633,
    814,
    996,
    1085,
    1179,
    1093,
    1098,
    1189,
    1109,
    1020,
    1196,
    1195,
    1194,
    1191,
    1372,
    1468,
    1213,
    1391,
    1569,
    1933,
    1846,
    1842,
    1929,
    1934,
    2115,
    2381,
    2470,
    2563,
    2564,
    2561,
    2373,
    2374,
    2375,
    2555,
    2376,
    2556,
    2826,
    2916,
    3006,
    3095,
    3275,
    3276,
    3182,
    3266,
    3351,
    3349,
    3435,
    3342,
    3338,
    3428,
    3427,
    3153,
    3152,
    3242,
    3513,
    3431,
    2898,
    3079,
    3083,
    2999,
    3091,
    3094,
    3010,
    3013,
    3284,
    3378,
    3291,
    3201,
    3197,
    3285,
    3287,
    3199,
    3289,
    3470,
    3478,
    3556,
    3554,
    3204,
    2477,
    2660,
    2571,
    2478,
    2655,
    2393,
    2213,
    2656,
    3014,
    2932,
    3018,
    3110,
    2850,
    2847,
    3027,
    3034,
    2860,
    2768,
    2852,
    2497,
    2045,
    1762,
    1939,
    2122,
    1952,
    1944,
    2120,
    2121,
    1856,
    2125,
    2128,
    2217,
    2486,
    2308,
    1948,
    1491,
    1401,
    1048,
    871,
    958,
    1227,
    1051,
    946,
    1305,
    1219,
    1041,
    949,
    1039,
    952,
    860,
    947,
    759,
    760,
    765,
    675,
    585,
    405,
    228,
    139,
    138,
    135,
    136,
    141,
    231,
    409,
    408,
    218,
    215,
    126,
    125,
    213,
    212,
    122,
    28,
    117,
    389,
    393,
    483,
    658,
    748,
    660,
    571,
    661,
    840,
    838,
    743,
    557,
    1005,
    918,
    827,
    825,
    736,
    1013,
    1478,
    877,
    705,
    702,
    967,
    966,
    602,
    505,
    594,
    597,
    510,
    600,
    509,
    689,
    514,
    692,
    784,
    517,
    427,
    154,
    148,
    149,
    75,
    78,
    73,
    246,
    345,
    349,
    267,
    264,
    260,
    350,
    174,
    88,
    265,
    536,
    538,
    448,
    444,
    356,
    87,
    86,
    172,
    259,
    530,
    623,
    891,
    806,
    714,
    801,
    1072,
    1166,
    899,
    985,
    1165,
    1257,
    1347,
    1438,
    1168,
    1078,
    1079,
    1887,
    1611,
    1335,
    1245,
    1156,
    1064,
    972,
    973,
    885,
    884,
    880,
    1057,
    1237,
    1240,
    1241,
    1236,
    1413,
    1412,
    1231,
    1229,
    1318,
    1407,
    1497,
    1768,
    1862,
    1776,
    1686,
    1509,
    1866,
    1957,
    1967,
    1878,
    1877,
    2502,
    2684,
    2594,
    2316,
    2399,
    2490,
    2584,
    2493,
    2492,
    2853,
    3217,
    3221,
    3130,
    3218,
    3309,
    3138,
    2964,
    3054,
    3058,
    2879,
    3234,
    3500,
    3492,
    3490,
    3579,
    3578,
    3484,
    3481,
    3391,
    3213,
    3212,
    3117,
    3480,
    3572,
    3570,
    3565,
    3566,
    3584,
    3322,
    3053,
    2870,
    2242,
    2328,
    2329,
    2066,
    2065,
    2060,
    2149,
    2151,
    1884,
    1795,
    1704,
    1614,
    1259,
    1528,
    1799,
    2423,
    2513,
    2609,
    2965,
    3056,
    3239,
    3598,
    3509,
    3508,
    3507,
    3506,
    3503,
    3231,
    3136,
    3316,
    3226,
    3046,
    2955,
    3133,
    3314,
    3227,
    2960,
    2596,
    2771,
    2953,
    2784,
    2159,
    2058,
    2144,
    2337,
    1978,
    2426,
    2607,
    2517,
    2057,
    1872,
    1962,
    1873,
    1696,
    1515,
    1600,
    1780,
    1694,
    1431,
    1251,
    1339,
    1338,
    1337,
    1607,
    1695,
    1871,
    2050,
    2140,
    2408,
    2588,
    2589,
    2590,
    2499,
    2409,
    2049,
    1424,
    1246,
    1065,
    882,
    613,
    612,
    519,
    430,
    339,
    338,
    334,
    957,
    1134,
    1314,
    1313,
    1492,
    1674,
    1678,
    1586,
    1582,
    1761,
    2031,
    2123,
    2214,
    2484,
    2843,
    2933,
    2936,
    3026,
    3115,
    3205,
    3296,
    3208,
    3119,
    3029,
    3030,
    3210,
    3388,
    3475,
    3473,
    3292,
    2931,
    2570,
    2298,
    2296,
    2295,
    2204,
    2110,
    2109,
    2199,
    2198,
    2197,
    2196,
    2195,
    2194,
    2103,
    2010,
    2008,
    1917,
    1916,
    1915,
    2004,
    2003,
    2002,
    1910,
    1908,
    1817,
    2086,
    2446,
    2447,
    2537,
    2627,
    2717,
    2716,
    2535,
    2264,
    1993,
    1812,
    1720,
    1628,
    1538,
    1448,
    1268,
    1178,
    1177,
    1089,
    1001,
    911,
    823,
    646,
    558,
    469,
    379,
    288,
    290,
    203,
    205,
    206,
    387,
    477,
    479,
    484,
    576,
    754,
    933,
    1024,
    1027,
    1117,
    1294,
    1475,
    1389,
    1209,
    938,
    762,
    586,
    856,
    1212,
    1207,
    1113,
    926,
    913,
    998,
    1087,
    1359,
    1358,
    1447,
    1718,
    1632,
    1363,
    908,
    649,
    650,
    556,
    458,
    457,
    361,
    360,
    450,
    451,
    453,
    365,
    467,
    468,
    738,
    739,
    573,
    487,
    758,
    1028,
    1030,
    948,
    1037,
    1393,
    1394,
    1395,
    1397,
    1487,
    1666,
    1663,
    1568,
    1566,
    1656,
    1838,
    1751,
    1841,
    2020,
    2289,
    2469,
    2649,
    2650,
    2734,
    2733,
    2644,
    2641,
    2730,
    2909,
    3000,
    3358,
    3534,
    3532,
    3440,
    3438,
    3165,
    2894,
    2718,
    2542,
    2450,
    2352,
    2349,
    2980,
    2811,
    2547,
    2466,
    3099,
    3274,
    3185,
    2923,
    2834,
    2744,
    2924,
    2920,
    2919,
    2827,
    2829,
    2742,
    2743,
    2745,
    2747,
    2749,
    2750,
    2751,
    2752,
    2665,
    2578,
    2669,
    2670,
    2762,
    2763,
    2854,
    2856,
    2857,
    3036,
    3304,
    3302,
    3297,
    3375,
    3458,
    3454,
    3451,
    3360,
    3270,
    3180,
    3179,
    3088,
    2997,
    2907,
    2818,
    2639,
    2640,
    2551,
    2461,
    2371,
    2370,
    2191,
    2101,
    2011,
    1922,
    1832,
    1742,
    1652,
    1562,
    1473,
    1563,
    1564,
    1654,
    1834,
    1835,
    1925,
    1926,
    2016,
    2017,
    1422,
    1507,
    1506,
    2133,
    2134,
    2224,
    2314,
    2313,
    2312,
    2222,
    2221,
    2311,
    2402,
    2405,
    2406,
    2407,
    2318,
    2229,
    2230,
    2141,
    2142,
    2233,
    2324,
    2415,
    2416,
    2507,
    2597,
    2598,
    2690,
    2602,
    2603,
    2604,
    2605,
    2695,
    2696,
    2786,
    2876,
    2966,
    3146,
    3325,
    3414,
    3413,
    3502,
    3592,
    3586,
    3496,
    3406,
    3407,
    3318,
    3229,
    3139,
    3049,
    2959,
    2778,
    2688,
    2599,
    2420,
    1882,
    1881,
    1790
  ]